import store from "@/store/store";
import { AuthService } from "@/services/auth.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export const startRouteMixin = {
  methods: {
    async navigateToStartRoute(user = null) {
      if (!user) {
        user = await AuthService.getUser().then(response =>
          JsonDenormalizer.denormalize(response.data)
        )
        .catch(err => {
          store.dispatch('Auth/clearToken');
        });
      }

      // The getUser may return a 403 if the
      // user is inactive/refused somehow.
      if ( ! user) return;

      const attributes = user.attributes || [];

      const attribute = attributes.find(
        attribute => attribute.code === "start_route"
      );

      const startRoute = attribute ? attribute.value : "profile";
      this.$router.push({ name: startRoute });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/startRouteMixin.js